// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"16b71a28","704":"44b45408","715":"48d6eec2","848":"12651ded","877":"68a2dbb5"}[chunkId] + ".chunk.js";
};